module.exports = __webpack_public_path__ + "img/bg_1440_0_1013.5dad6b47.png";